module.exports = __webpack_public_path__ + "static/media/icon_google.8c627930.svg";